<div class="participant-change">
  <div class="new-participant">
    <b>{{ participantChange.newParticipant }}</b> joined the chat | {{ participantChange.timestamp }}
  </div>
  <div class="participants">
    <b>{{ participantChange.otherParticipantNames.length + 1 }} participants:</b>
    {{ participantChange.otherParticipantNames.join(', ') }} and You.
  </div>
</div>
